/* Native product-information dialogs, with the product page held in place. */
(function () {
  'use strict';
  if (window.shProductPanelsReady) return;
  window.shProductPanelsReady = true;
  var active = null;
  var prepared = new WeakSet();

  function restore(dialog) {
    if (!active || active.dialog !== dialog) return;
    var previous = active;
    active = null;
    document.body.classList.remove('sh-product-panel-open');
    previous.styles.forEach(function (style) {
      if (style.value) document.body.style.setProperty(style.name, style.value, style.priority);
      else document.body.style.removeProperty(style.name);
    });
    previous.opener.setAttribute('aria-expanded', 'false');
    window.scrollTo({ left: previous.x, top: previous.y, behavior: 'instant' });
    if (previous.opener.isConnected) previous.opener.focus({ preventScroll: true });
  }

  function close(dialog) {
    if (dialog.open) dialog.close();
    restore(dialog);
  }

  function outside(event, dialog) {
    if (event.target !== dialog) return false;
    var rect = dialog.getBoundingClientRect();
    return event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom;
  }

  function prepare(dialog) {
    if (prepared.has(dialog)) return;
    prepared.add(dialog);
    var startedOutside = false;
    dialog.addEventListener('pointerdown', function (event) { startedOutside = outside(event, dialog); });
    dialog.addEventListener('click', function (event) {
      if (startedOutside && outside(event, dialog)) close(dialog);
      startedOutside = false;
    });
    dialog.addEventListener('cancel', function (event) { event.preventDefault(); close(dialog); });
    dialog.addEventListener('close', function () { restore(dialog); });
  }

  function open(opener) {
    var dialog = document.getElementById(opener.getAttribute('aria-controls'));
    if (!dialog || dialog.open) return;
    if (active) close(active.dialog);
    prepare(dialog);
    active = {
      dialog: dialog,
      opener: opener,
      x: window.scrollX,
      y: window.scrollY,
      styles: ['--sh-product-scroll-top', '--sh-product-scrollbar'].map(function (name) {
        return { name: name, value: document.body.style.getPropertyValue(name), priority: document.body.style.getPropertyPriority(name) };
      })
    };
    document.body.style.setProperty('--sh-product-scroll-top', -active.y + 'px');
    document.body.style.setProperty('--sh-product-scrollbar', Math.max(0, window.innerWidth - document.documentElement.clientWidth) + 'px');
    document.body.classList.add('sh-product-panel-open');
    try {
      dialog.showModal();
      opener.setAttribute('aria-expanded', 'true');
      dialog.querySelector('.sh-product-panel__body').scrollTop = 0;
      dialog.querySelector('.sh-product-panel__title').focus({ preventScroll: true });
    } catch (error) {
      close(dialog);
    }
  }

  document.addEventListener('click', function (event) {
    var opener = event.target.closest('[data-sh-product-panel-open]');
    if (opener) { open(opener); return; }
    var closer = event.target.closest('[data-sh-product-panel-close]');
    if (closer) close(closer.closest('.sh-product-panel'));
  });
  window.addEventListener('pagehide', function () { if (active) close(active.dialog); });
  document.addEventListener('shopify:section:unload', function (event) {
    if (active && event.target.contains(active.dialog)) close(active.dialog);
  });
})();
